module.exports = __webpack_public_path__ + "static/media/image.b113a97f.svg";